import { useEffect } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import type { EndorsementError } from 'src/app/pages/starterDashboardEndorsements/shared/hooks';
import { useToast } from 'src/app/shared/toast';

export function useEndorsementErrorToast(error: EndorsementError | null, clearError: () => void) {
	const { showToast } = useToast();
	const { translate } = useI18n();

	useEffect(() => {
		if (error) {
			showToast({
				variant: 'error',
				message:
					error.type === 'VALIDATION'
						? translate('corgi.petition.starter_dashboard_v2.endorsements.add.form_validation_error')
						: error.message,
			});
			clearError();
		}
	}, [error, showToast, clearError, translate]);
}
